import apiService from './apiService';

const BASE_URL = 'wildlifeDamage';
const FENCE_URL = 'wildlifeDamageMap';

/**
 * 鳥獣被害（柵含む）リスト取得
 */
export const getWildlifeDamageList = async (filterData) => {
    return apiService.post(`${BASE_URL}/getList`, filterData);
};

/**
 * 柵情報登録
 * @param {Object} fenceData - 登録する柵のデータ
 * @returns {Promise} API レスポンス
 */
export const registerFence = async (fenceData) => {
    return apiService.post(`${FENCE_URL}/regist`, fenceData);
};

/**
 * 柵情報更新
 * @param {Object} fenceData - 更新する柵のデータ
 * @returns {Promise} API レスポンス
 */
export const updateFence = async (fenceData) => {
    return apiService.post(`${FENCE_URL}/update`, fenceData);
};

/**
 * 柵情報削除（論理削除）
 * @param {Object} primaryKey - 削除対象データのプライマリキー
 * @returns {Promise} API レスポンス
 */
export const deleteFence = async (primaryKey) => {
    return apiService.post(`${FENCE_URL}/delete`, primaryKey);
};
